import { render, staticRenderFns } from "./SpecialList.vue?vue&type=template&id=d54bd176&"
import script from "./SpecialList.vue?vue&type=script&lang=js&"
export * from "./SpecialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports